import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.5 7.3125C12.75 6.65625 12.1875 6.28125 12.1875 5.625V4.6875C12.1875 2.0625 10.125 0 7.5 0C4.875 0 2.8125 2.0625 2.8125 4.6875V5.625C2.8125 6.28125 2.25 6.65625 1.5 7.3125C0.75 7.875 0 8.4375 0 9.375C0 12 5.71875 12.1875 7.5 12.1875C9.28125 12.1875 15 12 15 9.375C15 8.4375 14.25 7.875 13.5 7.3125Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.2187 13.0312C9.1875 13.125 8.34375 13.125 7.5 13.125C6.65625 13.125 5.8125 13.125 4.78125 13.0312C5.15625 14.1562 6.1875 15 7.5 15C8.8125 15 9.84375 14.1562 10.2187 13.0312Z",
		fill: "currentColor"
	})]
});
export default SvgIconBell;
